import React, { useReducer, useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import PropTypes from "prop-types";
import { FormattedDate } from "react-intl";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";

import { alertReducer } from "../Alert/store/reducer";
import { defaultState, parseAlert, initialize } from "../Alert/store/store";
import style from "../Alert/Alert.module.scss";
import Comparer, { personChangeType } from "./Comparer";
import ModalError from "../../Profile/Modal/ModalError";
import { parseDate } from "../../../utils";

const getAccountType = {
  Holders: "Holders",
  Questions: "Questions",
  KYC: "KYC",
  Documents: "Documents",
  InvestmentProfile: "InvestmentProfile",
  Profile: "Profile",
  SignatureSets: "SignatureSets",
  References: "References",
  BankAccounts: "BankAccounts",
};

const AccountComparer = ({ open, toggle, ...props }) => {
  const [requestedModification, setModifications] = useState(undefined);
  const [account, setAccount] = useState(undefined);
  const [person, setPerson] = useState(undefined);
  const [currencies, setCurrencies] = useState(undefined);
  const [closing, setClosing] = useState(false);
  const [saving, setSaving] = useState(false);
  const [state, dispatch] = useReducer(
    alertReducer,
    defaultState(),
    initialize(props)
  );
  const [modalError, setModalError] = useState({
    open: false,
    message: "",
  });

  const { ui, alertEv } = state;

  const fetchAccount = (id, sector) => {
    const body = {
      AccountGetInfo: {
        GetAccountDataId: id,
        GetAccountDataType: sector,
      },
    };
    props.fetchs.account(body, (response) => {
      if (response && response.SDTAccount) {
        setAccount(response.SDTAccount);
      }
    });
  };

  const fetchPerson = (id) => {
    const body = {
      personId: id,
    };
    props.fetchs.person(body, (response) => {
      if (response && response.personInfo) {
        setPerson(response.personInfo);
      }
    });
  };

  const fetchCurrencies = () => {
    props.fetchs.currencies({}, (response) => {
      if (response && response.currencies) setCurrencies(response.currencies);
    });
  };

  const fetchAlert = (id) => {
    props.fetchs.alert({ id }, (r) => {
      if (r && r.alertEvent) {
        if (ui.loadings.alert) {
          dispatch({ type: "UPDATE_LOADING", loadings: { alert: false } });
        }
        dispatch({ type: "ALERT_UPDATE", alert: parseAlert(r.alertEvent) });
        if (r.alertEvent.refTag) {
          const modifications = JSON.parse(r.alertEvent.refTag);
          setModifications(modifications);
          fetchCurrencies();
          if (modifications.Account) {
            fetchAccount(
              modifications.Account.AccountId,
              modifications.AccountChangeType
            );
            if (
              modifications.AccountChangeType === getAccountType.Profile ||
              modifications.AccountChangeType === getAccountType.BankAccounts
            ) {
            }
          } else {
            fetchPerson(modifications.Person.PersonId);
          }
        }
      }
    });
  };

  const handleClose = () => {
    const eventIN = { ...alertEv };
    eventIN.status = "Closed";
    setClosing(true);
    props.fetchs.updateAlert({ eventIN }, () => {
      setClosing(false);
      setSaving(false);
      toggle();
    });
  };

  const handleReject = () => {
    const eventIN = { ...alertEv };
    eventIN.status = "Rejected";
    setClosing(true);
    props.fetchs.updateAlert({ eventIN }, () => {
      setClosing(false);
      setSaving(false);
      toggle();
    });
  };
  
  

  const toggleModalError = (e, message) =>
    setModalError({
      open: !modalError.open,
      message,
    });

  const handleSave = () => {
    setSaving(true);
    if (requestedModification.Account) {
      const body = {
        account: requestedModification.Account,
        accountChangeType: requestedModification.AccountChangeType,
      };
      props.fetchs.updateAccount(body, (response) => {
        if (response.result.Code === 200) {
          handleClose();
        } else {
          toggleModalError(
            {},
            response && response.result
              ? response.result.Description
              : "Server Error"
          );
          setSaving(false);
        }
      });
    } else {
      switch (requestedModification.PersonChangeType) {
        case personChangeType.Information:
          props.fetchs.updatePerson(
            {
              person: requestedModification.Person,
            },
            (response) => {
              if (response.result.Code === 200) {
                handleClose();
              } else {
                toggleModalError(
                  {},
                  response && response.result
                    ? response.result.Description
                    : "Server Error"
                );
                setSaving(false);
              }
            }
          );
          break;
        case personChangeType.Documents:
          props.fetchs.updatePersonDocuments(
            {
              person: requestedModification.Person,
              file: requestedModification.file,
              remove: requestedModification.delete,
            },
            (response) => {
              if (response.result.Code === 200) {
                handleClose();
              } else {
                toggleModalError(
                  {},
                  response && response.result
                    ? response.result.Description
                    : "Server Error"
                );
                setSaving(false);
              }
            }
          );
          break;
        case personChangeType.Phone:
          props.fetchs.updatePersonPhone(
            {
              person: requestedModification.Person,
              file: requestedModification.file,
              delete: requestedModification.delete,
            },
            (response) => {
              if (response.result.Code === 200) {
                handleClose();
              } else {
                toggleModalError(
                  {},
                  response && response.result
                    ? response.result.Description
                    : "Server Error"
                );
                setSaving(false);
              }
            }
          );
          break;
        case personChangeType.ShareHolders:
          props.fetchs.updatePersonShareHolder(
            {
              person: requestedModification.Person,
              edit: requestedModification.aux,
            },
            (response) => {
              if (response.result.Code === 200) {
                handleClose();
              } else {
                toggleModalError(
                  {},
                  response && response.result
                    ? response.result.Description
                    : "Server Error"
                );
                setSaving(false);
              }
            }
          );
          break;
        case personChangeType.LegalAddress:
          props.fetchs.fetchUpdatePersonLegalAddress(
            {
              person: requestedModification.Person,
              edit: requestedModification.aux,
              delete: requestedModification.delete,
            },
            (response) => {
              if (response.result.Code === 200) {
                handleClose();
              } else {
                toggleModalError(
                  {},
                  response && response.result
                    ? response.result.Description
                    : "Server Error"
                );
                setSaving(false);
              }
            }
          );
          break;
        case personChangeType.FiscalResidence:
          props.fetchs.updatePersonFiscalResidences(
            {
              person: requestedModification.Person,
              delete: requestedModification.delete,
            },
            (response) => {
              if (response.result.Code === 200) {
                handleClose();
              } else {
                toggleModalError(
                  {},
                  response && response.result
                    ? response.result.Description
                    : "Server Error"
                );
                setSaving(false);
              }
            }
          );
          break;

        case personChangeType.KYC:
          props.fetchs.fetchPersonKYC(
            {
              person: requestedModification.Person,
              edit: requestedModification.aux,
            },
            (response) => {
              if (response.result.Code === 200) {
                handleClose();
              } else {
                toggleModalError(
                  {},
                  response && response.result
                    ? response.result.Description
                    : "Server Error"
                );
                setSaving(false);
              }
            }
          );
          break;
        case personChangeType.BankAccount:
          props.fetchs.fetchUpdatePersonBankAccount(
            {
              person: requestedModification.Person,
              edit: requestedModification.aux,
              delete: requestedModification.delete,
            },
            (response) => {
              if (response.result.Code === 200) {
                handleClose();
              } else {
                toggleModalError(
                  {},
                  response && response.result
                    ? response.result.Description
                    : "Server Error"
                );
                setSaving(false);
              }
            }
          );
          break;
        case personChangeType.Suitability:
          props.fetchs.fetchPersonSuitability(
            { person: requestedModification.Person },
            (response) => {
              if (response.result.Code === 200) {
                handleClose();
              } else {
                toggleModalError(
                  {},
                  response && response.result
                    ? response.result.Description
                    : "Server Error"
                );
                setSaving(false);
              }
            }
          );
          break;
        case personChangeType.ExtendedData:
          props.fetchs.fetchUpdatePersonExtendedData({ personId: requestedModification.Person.PersonId, extendedData: requestedModification.Person.PersonExtendedData }, (response) => {
            if (response.result.Code === 200) {
              handleClose();
            } else {
              toggleModalError(
                {},
                response && response.result ? response.result.Description : "Server Error"
              );
              setSaving(false);
            }
          });
        break;

        default:
          break;
      }
    }
  };

  useEffect(() => {
    fetchAlert(alertEv.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alertEv.id]);

  const { user } = props;
  return (
    <Modal
      isOpen={open}
      className={style.modal}
      style={{
        maxWidth: !requestedModification || !account ? "500px" : "800px",
      }}
    >
      <ModalHeader
        toggle={toggle}
        className={style.header}
        style={{ padding: "10px 15px" }}
      >
        <div>{alertEv.title}</div>
        <div>
          <i className="fa fa-exclamation-triangle mr-2" aria-hidden="true" />
          <FormattedDate value={parseDate(alertEv.date)} />
        </div>
      </ModalHeader>
      <ModalBody
        className={style.body}
        style={{
          textAlign: !requestedModification || !account ? "center" : "left",
        }}
      >
        <Comparer
          requestedModification={requestedModification}
          account={account}
          currencies={currencies}
          person={person}
          fetchFile={props.fetchs.getComplianceAlertFile}
        />
        <ModalError {...modalError} onToggle={toggleModalError} />
      </ModalBody>
      <ModalFooter>
        <Button
          disabled={saving || closing}
          color="light btn"
          onClick={() => toggle()}
        >
          Close
        </Button>
        {user &&
          user.role === "Compliance" &&
          alertEv.status === "WorkingCompliance" && (
            <React.Fragment>
              <LaddaButton
                className="btn btn-ladda btn-primary"
                loading={closing && !saving}
                disabled={
                  !requestedModification || !(account || person) || saving
                }
                onClick={handleReject}
                data-style={EXPAND_RIGHT}
              >
                {closing && !saving ? "Rejecting..." : "Reject"}
              </LaddaButton>
              <LaddaButton
                className="btn btn-ladda btn-primary"
                loading={saving}
                disabled={
                  !requestedModification || !(account || person) || closing
                }
                onClick={handleSave}
                data-style={EXPAND_RIGHT}
              >
                {saving && !closing ? (
                  "Saving..."
                ) : (
                  <React.Fragment>
                    {closing && saving ? "Closing..." : "Save"}
                  </React.Fragment>
                )}
              </LaddaButton>
            </React.Fragment>
          )}
      </ModalFooter>
    </Modal>
  );
};

AccountComparer.propTypes = {
  open: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  fetchs: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

export default AccountComparer;
